const PrivacyPolicy = () => {
  return (
    <div className="mx-auto p-6 sm:p-8 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-6 text-center">
        Privacy Policy
      </h1>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        1. Introduction
      </h2>
      <p className="text-gray-700 leading-relaxed mb-6">
        <strong>Sunday School</strong> is committed to protecting your privacy
        and ensuring that your personal information is handled in a safe and
        responsible manner. This Privacy Policy explains how we collect, use,
        and safeguard your information when you visit our website or
        participate in our programs and activities.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        2. Information We Collect
      </h2>
      <p className="text-gray-700 mb-4">
        We may collect the following types of information:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>
          <strong>Personal Information:</strong> Your name, email address, phone
          number, or other contact details provided when registering, contacting
          us, or signing up for classes or programs.
        </li>
        <li>
          <strong>Participation Details:</strong> Information about your class
          involvement, age group, or volunteer activity related to Sunday
          School.
        </li>
        <li>
          <strong>Usage Data:</strong> Data about how you use our website,
          including IP address, browser type, and pages visited.
        </li>
        <li>
          <strong>Cookies:</strong> Small text files stored on your device to
          help us improve your browsing experience and personalize content.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        3. How We Use Your Information
      </h2>
      <p className="text-gray-700 mb-4">
        We use the information we collect for the following purposes:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>To manage Sunday School registrations, classes, and events.</li>
        <li>To communicate updates, lessons, or community announcements.</li>
        <li>
          To provide safe, personalized, and effective ministry experiences.
        </li>
        <li>To respond to inquiries or prayer requests.</li>
        <li>To improve our website and outreach programs.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        4. Sharing Your Information
      </h2>
      <p className="text-gray-700 mb-4">
        We respect your privacy and do not sell or rent your personal
        information. However, we may share information in the following cases:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>
          <strong>With Ministry Staff or Volunteers:</strong> To help coordinate
          classes, communications, and program-related activities.
        </li>
        <li>
          <strong>With Service Providers:</strong> Trusted third parties who
          assist us with website management, communications, or data processing.
        </li>
        <li>
          <strong>Legal Requirements:</strong> When required by law or to
          protect the rights and safety of Sunday School, its members, or the
          public.
        </li>
      </ul>

      <p className="text-gray-700 mb-6">
        Sunday School collects information voluntarily given by participants for
        ministry and educational purposes only. All personal data is handled
        responsibly and shared only with authorized personnel who manage
        programs or communication.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        5. Data Security
      </h2>
      <p className="text-gray-700 mb-6">
        We take reasonable measures to protect your information from
        unauthorized access, alteration, or disclosure. While we strive to use
        industry-standard safeguards, please note that no online transmission or
        storage system is completely secure.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        6. Your Rights
      </h2>
      <p className="text-gray-700 mb-4">You have the right to:</p>
      <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>Request access to the personal data we hold about you.</li>
        <li>Request corrections to inaccurate or outdated information.</li>
        <li>
          Request deletion of your personal information, subject to our legal or
          administrative obligations.
        </li>
        <li>
          Opt out of non-essential communications or newsletter updates at any
          time.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        7. Children’s Privacy
      </h2>
      <p className="text-gray-700 mb-6">
        Sunday School values the privacy of children. We do not knowingly
        collect personal information from children under 13 without parental
        consent. Parents or guardians may review, edit, or request the deletion
        of their child’s information by contacting us.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        8. Changes to This Privacy Policy
      </h2>
      <p className="text-gray-700 mb-6">
        We may update this Privacy Policy from time to time to reflect changes
        in our practices or legal obligations. The updated policy will always be
        posted on this page, with the latest revision date indicated at the top.
        Continued use of our website or programs after any update means you
        accept the revised policy.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        9. Contact Us
      </h2>
      <p className="text-gray-700 mb-6">
        If you have questions or concerns about our Privacy Policy or how we
        handle your personal data, please contact us at:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-2">
        <li>
          <strong>Website:</strong> sundayschools.net
        </li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;